import { SmartForm, MultiSelect } from '@certemy/ui-components';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  forwardRef,
  ChangeDetectorRef,
  OnChanges,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { noop } from '@certemy/common';

@Component({
  selector: 'cm-multiselect-to-checkbox-wrapper',
  templateUrl: './multiselect-to-checkbox-wrapper.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiselectToCheckboxWrapperComponent),
      multi: true,
    },
  ],
})
export class MultiselectToCheckboxWrapperComponent implements ControlValueAccessor, OnInit, OnChanges {
  @Input() options: SmartForm.FieldOption[] = [];
  @Input() formValues: { [id: string]: boolean };

  private _formValues: { [id: string]: boolean };

  @Input() disabled = false;
  @Input() valueType: MultiSelect.ValueType = MultiSelect.ValueType.Id;
  @Input() params;
  @Input() showErrors: boolean;
  @Input() template: TemplateRef<any> | string = '';
  @Output() formValuesChange = new EventEmitter();

  isDisabled = false;
  MULTI_SELECT_VALUE_TYPE = MultiSelect.ValueType;
  selectedOptions = [];

  private onTouched = noop;
  private propagateChange = noop;

  constructor(private changeDetector: ChangeDetectorRef) {}

  ngOnChanges(changes) {
    if (changes.formValues) {
      if (this.options) {
        this._formValues =
          this.formValues || this.options.map(({ id }) => id).reduce((o, id) => ({ ...o, [id]: false }), {});
        this.selectedOptions = this.options.filter((option) => this._formValues[option.id]);
      }
    }
  }

  writeValue(values: { [id: string]: boolean }) {
    this.formValues = values;
    this.changeDetector.markForCheck();
  }

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: () => any): void {
    this.onTouched = fn;
  }

  ngOnInit() {
    this.options = this.options || [];
    this.params = {
      ...this.params,
      template: this.template,
    };
  }

  onMultiSelectValueChange(selectedValues: { id: number; name: string }[]) {
    this.resetFormValues();
    this.setSelectedValues(selectedValues);

    this.formValuesChange.emit(this._formValues);
  }

  resetFormValues() {
    Object.keys(this._formValues).forEach((id) => (this._formValues[id] = false));
  }

  setSelectedValues(selectedValues: { id: number; name: string }[]) {
    selectedValues.forEach((option) => (this._formValues[option.id] = true));
  }
}
